import { Navigate, useLocation } from "react-router-dom";

type RedirectWithSearchProps = {
  to: string;
};

// Redirects to a new path while keeping the query string, e.g. ?lang=ar.
export const RedirectWithSearch = ({ to }: RedirectWithSearchProps) => {
  const { search } = useLocation();

  return <Navigate to={{ pathname: to, search }} replace />;
};
